export default __webpack_public_path__ + "static/media/icons8-folder.468031c8.svg";